import { useSelector } from 'react-redux';
import { isEqual } from 'underscore';
import type { RootState } from '../store/models';

export type UtmParams = {
  utm_source?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_medium?: string;
  utm_term?: string;
};

const useGetUtmParams = (): UtmParams => useSelector((state: RootState) => (
  {
    utm_source: state?.route?.params?.utm_source,
    utm_campaign: state?.route?.params?.utm_campaign,
    utm_content: state?.route?.params?.utm_content,
    utm_medium: state?.route?.params?.utm_medium,
    utm_term: state?.route?.params?.utm_term,
  }
), isEqual);

export default useGetUtmParams;
